import _SvgIcon from "@mui/material/SvgIcon";
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from 'react';
export function CargoBikeIcon(props) {
  return /*#__PURE__*/React.createElement(_SvgIcon, _extends({
    viewBox: "0 0 32 22"
  }, props), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4887_32030)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.1629 3.89742C20.1629 3.89742 16.805 3.67559 16.5831 3.89742C16.0262 4.45441 15.3392 6.57128 14.7649 8.67046C14.1089 11.0685 13.6 13.4435 13.6 13.4435H4M23.2268 8.67046L18.4514 7.39883L15.3899 6.5553L21.6268 13.4435M23.2268 8.67046L21.6268 13.4435M23.2268 8.67046L24.0268 6.59883M21.6268 13.4435H28.4268M22.8268 6.19883L25.2268 6.99883",
    fill: "none",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: "1.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "28",
    cy: "13.3984",
    fill: "none",
    r: "3.4",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: "4",
    cy: "13.3984",
    fill: "none",
    r: "3.4",
    stroke: "currentColor",
    strokeWidth: "1.2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.6 13.4V7H4.79999L7.59999 13.4H13.6Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeLinejoin: "round",
    strokeWidth: "0.8"
  })), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4887_32030"
  }, /*#__PURE__*/React.createElement("rect", {
    fill: "white",
    height: "17.6",
    transform: "translate(0 2.19922)",
    width: "32"
  }))));
}